import { c as _c } from "react/compiler-runtime";
import type { Address } from '@newfront-insurance/address-api';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, Padding, Text, Spacing, Flexbox, MessageBox } from '@newfront-insurance/core-ui';
import { useState, type JSX } from 'react';
import type { internationalStreet } from 'smartystreets-javascript-sdk';
import { formatCandidateToAddress } from '../../../utils/format-street-address';
import { SelectableAddress } from '../selectable-address';
interface Props {
  handleClose: () => void;
  isOpen: boolean;
  candidates: internationalStreet.Candidate[];
  enteredAddress: Address;
  onSelectAddress: (selectedAddress?: Address) => void;
  width?: string;
}
export function VerifyInternationalAddressModal(t0) {
  const $ = _c(47);
  const {
    isOpen,
    handleClose,
    enteredAddress,
    candidates,
    onSelectAddress,
    width
  } = t0;
  const [selectedCandidate, setSelectedCandidate] = useState();
  const [selectEnteredAddress, setSelectedAddress] = useState(false);
  if ((!candidates || candidates.length === 0) && !selectedCandidate && !selectEnteredAddress) {
    setSelectedAddress(true);
    setSelectedCandidate(enteredAddress);
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function message(text) {
      return <Padding y={12}><MessageBox variant="alert" message={text} /></Padding>;
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const message = t1;
  const t2 = !!isOpen;
  let t3;
  if ($[1] !== handleClose) {
    t3 = () => handleClose();
    $[1] = handleClose;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== handleClose) {
    t4 = <ModalHeader titleText="Verify international address" onClose={() => handleClose()} />;
    $[3] = handleClose;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Text>Verification results</Text>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== candidates) {
    t6 = (!candidates || candidates.length === 0) && message("No verification results found for this address");
    $[6] = candidates;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== candidates || $[9] !== enteredAddress || $[10] !== selectEnteredAddress || $[11] !== selectedCandidate) {
    t7 = candidates.length > 0 && candidates.map(candidate => {
      const formattedCandidateAddress = formatCandidateToAddress(candidate);
      const status = candidate.analysis.verificationStatus;
      if (status === "None") {
        if (!selectedCandidate && !selectEnteredAddress) {
          setSelectedAddress(true);
          setSelectedCandidate(enteredAddress);
        }
        return message(`This address could not be verified.
                    If you wish to proceed with your entered address please select it below,
                    otherwise click Cancel`);
      }
      return <SelectableAddress key={formattedCandidateAddress.formattedAddress} isActive={selectEnteredAddress || !candidates || selectedCandidate?.formattedAddress === formattedCandidateAddress.formattedAddress} onChange={() => {
        const formattedCandidate = formatCandidateToAddress(candidate);
        setSelectedCandidate(formattedCandidate);
      }} candidate={candidate} />;
    });
    $[8] = candidates;
    $[9] = enteredAddress;
    $[10] = selectEnteredAddress;
    $[11] = selectedCandidate;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <div>{t5}{t6}{t7}</div>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Text>Entered address</Text>;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = selectEnteredAddress || selectedCandidate?.formattedAddress === enteredAddress.formattedAddress;
  let t11;
  if ($[17] !== enteredAddress) {
    t11 = () => setSelectedCandidate(enteredAddress);
    $[17] = enteredAddress;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== enteredAddress || $[20] !== t10 || $[21] !== t11) {
    t12 = <SelectableAddress isActive={t10} onChange={t11} enteredAddress={enteredAddress} />;
    $[19] = enteredAddress;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12 || $[24] !== t8) {
    t13 = <Padding size={24}>{t8}{t9}{t12}</Padding>;
    $[23] = t12;
    $[24] = t8;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== handleClose) {
    t14 = <Button type="button" size="secondary" onClick={() => handleClose()}>Cancel</Button>;
    $[26] = handleClose;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Spacing width={12} />;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  const t16 = !selectedCandidate;
  let t17;
  if ($[29] !== onSelectAddress || $[30] !== selectedCandidate) {
    t17 = () => onSelectAddress(selectedCandidate);
    $[29] = onSelectAddress;
    $[30] = selectedCandidate;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t16 || $[33] !== t17) {
    t18 = <Button type="submit" disabled={t16} onClick={t17}>Select address</Button>;
    $[32] = t16;
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t14 || $[36] !== t18) {
    t19 = <ModalFooter><Flexbox alignItems="center" justifyContent="flex-end">{t14}{t15}{t18}</Flexbox></ModalFooter>;
    $[35] = t14;
    $[36] = t18;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t13 || $[39] !== t19 || $[40] !== t4) {
    t20 = <ModalBody>{t4}{t13}{t19}</ModalBody>;
    $[38] = t13;
    $[39] = t19;
    $[40] = t4;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t2 || $[43] !== t20 || $[44] !== t3 || $[45] !== width) {
    t21 = <Modal isOpen={t2} onToggle={t3} width={width}>{t20}</Modal>;
    $[42] = t2;
    $[43] = t20;
    $[44] = t3;
    $[45] = width;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  return t21;
}